import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=e515986c&scoped=true"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"
import style1 from "./Book.vue?vue&type=style&index=1&id=e515986c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e515986c",
  null
  
)

export default component.exports